import { render, staticRenderFns } from "./EventFiles.vue?vue&type=template&id=95c6ca60&"
import script from "./EventFiles.vue?vue&type=script&lang=js&"
export * from "./EventFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports